<template>
    <v-layout row>
        <v-flex md6 offset-md3>
            <v-data-table
                    :headers="headers"
                    :items="data"
                    :loading="loading"
                    class="elevation-1"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="pagination"
                    disable-initial-sort
            >
                <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
                <template v-slot:items="props">
                    <td class="text-xs-left">{{ $moment(props.item.date).format('DD-MM-YYYY HH:mm') }}</td>
                    <td class="text-xs-left">{{ props.item.type }}</td>
                    <td class="text-xs-left" v-bind:class="props.item.amount<0?'text-negative':''">{{ props.item.amount }}</td>
                    <td class="text-xs-left">{{ props.item.balance }}</td>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
    import { VDataTable, VProgressLinear, VLayout, VFlex } from 'vuetify/lib'
    import AuthRepository from "@/repositories/AuthRepository";

    export default {
        components: {
            VDataTable, VProgressLinear, VLayout, VFlex
        },
        data() {
            return {
                user_id: null,
                loading: true,
                headers: [
                    { text: 'Date', align: 'left', value: 'date' },
                    { text: 'Type', align: 'left', value: 'type' },
                    { text: 'Quantity', align: 'left', value: 'amount' },
                    { text: 'Balance', align: 'left', value: 'balance' }
                ],
                data: [],
                rowsPerPageItems: [10, 20, 30, 40],
                pagination: {
                    rowsPerPage: 20
                },
            }
        },
        created() {
            this.fetch();
        },
        methods: {
            async fetch() {
                let transactions = await AuthRepository.getTransactions();
                this.data = transactions.data.transactions;
                this.loading = false;
            }
        }
    }
</script>

<style scoped>
    .text-negative {
        color:#f00;
    }
</style>
